import { motion } from "framer-motion";
import { ArrowDown, Phone, MessageSquare } from "lucide-react";

const HERO_IMG = "https://images.pexels.com/photos/18318725/pexels-photo-18318725.png";

const lines = ["The Black Car", "Standard of", "New York."];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.18, delayChildren: 0.5 } },
};
const lineMask = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] } },
};

export const Hero = ({ phone = "" }) => {
  const digits = phone.replace(/[^0-9]/g, "");
  const tel = `+${digits.length === 10 ? "1" + digits : digits}`;
  const smsBody = encodeURIComponent(
    "Hi LUXERIDENY, I'd like to book a ride. Pickup: , Drop-off: , Date/Time: , Passengers: "
  );
  const smsHref = `sms:${tel}?&body=${smsBody}`;
  return (
  <section id="top" className="relative min-h-screen flex flex-col justify-end overflow-hidden">
    <motion.div
      initial={{ scale: 1.15 }}
      animate={{ scale: 1 }}
      transition={{ duration: 2.4, ease: [0.22, 1, 0.36, 1] }}
      className="absolute inset-0"
    >
      <img src={HERO_IMG} alt="New York skyline at night" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/55" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-black/40" />
    </motion.div>

    <div className="relative z-10 max-w-[1400px] mx-auto w-full px-6 lg:px-10 pb-24 lg:pb-32">
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 1 }}
        className="overline mb-8"
      >
        Chauffeured Escalade &amp; Suburban · Est. New York
      </motion.p>

      <motion.h1
        variants={container}
        initial="hidden"
        animate="show"
        className="font-serif text-5xl sm:text-6xl lg:text-8xl leading-[0.92] tracking-tighter text-[#F5F5F0]"
      >
        {lines.map((line, i) => (
          <span key={i} className="block overflow-hidden">
            <motion.span variants={lineMask} className="block">
              {line}
            </motion.span>
          </span>
        ))}
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="mt-10 max-w-xl text-[#8A8A8A] text-base lg:text-lg font-light"
      >
        Private black-SUV transportation across the Hamptons, Manhattan and every
        airport in the tri-state area. Discreet. Punctual. Effortless.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.75, duration: 1 }}
        className="mt-10 flex flex-wrap items-center gap-5"
      >
        <a
          href={`tel:${tel}`}
          data-testid="hero-call-btn"
          className="group inline-flex items-center gap-3 bg-gold text-black px-8 py-4 hover:tracking-widest hover:bg-gold-hover transition-[letter-spacing,background-color] duration-500"
        >
          <Phone className="w-4 h-4" />
          <span className="overline text-black">Call to Book</span>
        </a>
        <a
          href={smsHref}
          data-testid="hero-text-btn"
          className="group inline-flex items-center gap-3 border border-gold/50 text-gold px-8 py-4 hover:bg-gold hover:text-black transition-colors duration-400"
        >
          <MessageSquare className="w-4 h-4" />
          <span className="overline text-gold group-hover:text-black">Text to Book</span>
        </a>
        <a
          href="#book"
          data-testid="hero-reserve-btn"
          className="overline text-[#F5F5F0] border-b border-white/20 pb-1 hover:border-gold hover:text-gold transition-colors duration-400"
        >
          Reserve Online
        </a>
      </motion.div>
    </div>

    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 1, 1, 0], y: [0, 8, 0] }}
      transition={{ delay: 2, duration: 2.4, repeat: Infinity }}
      className="absolute bottom-8 right-10 hidden lg:block text-gold"
    >
      <ArrowDown className="w-5 h-5" />
    </motion.div>
  </section>
  );
};

export default Hero;
